import type { PrismicDocument } from '@prismicio/client';
import { usePrismicDocumentByUID } from '@prismicio/vue';
import _ from 'lodash';
import { computed, type ComputedRef, type Ref } from 'vue';

export function useSlice(documentType: string, uid: string) {
  const documentResult = usePrismicDocumentByUID(documentType, uid);
  const document: Ref<PrismicDocument | null> = documentResult.data;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const slices: ComputedRef<Record<string, any>> = computed(() =>
    _.mapKeys(document.value?.data?.body, value => value.slice_type)
  );

  return {
    document,
    slices,
  };
}
